import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
`;

export const ModalName = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
`;

export const LastUpdatedDate = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
    margin-top: 4px;
`;

export const StatusText = styled.div<{ background: string; color: string }>`
    margin-top: 14px;
    background: ${(props) => props.background};
    border-radius: 4px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => props.color};
    padding: 6px;
    width: fit-content;
`;

export const PlanDetailsWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 12px;
    flex-direction: column;
    background: #ffffff;
    border-radius: 12px;
    margin-top: 26px;
    border: 1px solid #e7e7f0;
    box-sizing: border-box;
`;

export const RowWrapper = styled.div`
    display: flex;
    margin-top: 10px;
    align-items: flex-start;
    gap: 12px;
`;

export const LabelText = styled.div`
    display: flex;
    flex: 1;
    min-width: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const ValueText = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    min-width: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    text-align: end;
    overflow-wrap: anywhere;
    word-break: break-word;
`;

export const Hr = styled.div`
    width: 100%;
    height: 0px;
    opacity: 0.1;
    border: 1px solid #040222;
    margin-top: 10px;
`;

export const CustomerDetailsWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-top: 24px;
`;

export const CustomerMobileFlex = styled.div`
    display: flex;
    flex: 2;
    flex-direction: column;
`;

export const CustomerMobileText = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const CustomerMobileNumber = styled.div`
    display: flex;
    margin-top: 6px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
`;

export const CustomerAmountFlex = styled(CustomerMobileFlex)`
    flex: 1;
    align-items: flex-end;
`;

export const ResendLinkWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-top: 32px;
`;

export const ResendLinkText = styled.div`
    display: flex;
    margin-top: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    align-items: center;
    color: #1b73e8;
    justify-content: center;
`;
